import { render } from "./TeamSelection-v2.vue?vue&type=template&id=f599589a&scoped=true"
import script from "./TeamSelection-v2.vue?vue&type=script&lang=js"
export * from "./TeamSelection-v2.vue?vue&type=script&lang=js"

import "./TeamSelection-v2.vue?vue&type=style&index=0&id=f599589a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f599589a"]])

export default __exports__